import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationBody } from '../../_types/awb';

export const createAccreditationBody = async (
  data: AccreditationBody,
  callback?: (data: AccreditationBody) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies`;
  await fetcher({
    url,
    method: 'post',
    body: data,
  })
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const updateAccreditationBody = async (
  id: string,
  data: AccreditationBody,
  callback?: (data: AccreditationBody) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${id}`;
  await fetcher({
    url,
    method: 'put',
    body: data,
  })
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      console.warn('update err', err);
      if (onError) handleError(err, { onError });
    });
};

export const destroyAccreditationBody = async (
  id: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${id}`;
  await fetcher({
    url,
    method: 'delete',
    body: {},
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      console.warn('update err', err);
      if (onError) handleError(err, { onError });
    });
};
